import { Flex } from "antd"
import { Modal } from "ui/Modal"
import { Text, Title } from "ui/Typography"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import WarningOutlinedWithBg from "ui/WarningOutlinedWithBg"
import { spacings } from "themes/variables"
import { useSelector } from "react-redux"
import ActionButtons from "../ActionButtons"

const DeleteAccountWarning = ({ visible, onCancel, onDelete, primaryColor }) => {
  const { t } = useTranslation()
  const isDeleteCheckLoading = useSelector((state) => state.user?.checkUserDeleteAble?.loading)

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      centered
      title={
        <Flex justify="center">
          <WarningOutlinedWithBg />
        </Flex>
      }
      width={450}
    >
      <Flex gap={spacings.M} vertical>
        <Title level={3}>{t("settings.delete_account")}</Title>
        <Text>{t("settings.delete_account_confirm")}</Text>
        <ActionButtons
          primaryColor={primaryColor}
          wrapperClassName="mt-xs"
          onSecondary={onCancel}
          onPrimary={onDelete}
          primaryLabel={t("settings.delete_account")}
          primaryDisabled={isDeleteCheckLoading}
          primaryLoading={isDeleteCheckLoading}
          secondaryDisabled={isDeleteCheckLoading}
        />
      </Flex>
    </Modal>
  )
}

DeleteAccountWarning.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  onDelete: PropTypes.func,
  primaryColor: PropTypes.string
}

export default DeleteAccountWarning
